import { Component, OnInit, Input } from '@angular/core';
import { SasisopaService } from '../../../../services/sasisopa.service';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import * as moment from 'moment';
import { FirebaseStorageService } from '../../../../services/firebase-storage.service';
import { v4 as uuidv4 } from 'uuid';
import {finalize} from 'rxjs/operators';


@Component({
  selector: 'ngx-follow-up-service',
  templateUrl: './follow-up-service.component.html',
  styleUrls: ['./follow-up-service.component.scss']
})
export class FollowUpServiceComponent implements OnInit {
  @Input() stationId: string;
  @Input() action: string;
  @Input() infoEdit: any;
  loading = false;
  data = {
    station_id: '',
    document_name: '',
    entity: '',
    creation_date: '',
    update_date: '',
    backup_mode: '',
    final_disposition: {
      dead_file: true,
      destruction: false
    },
    files: []
  };
  today = new Date();
  year = moment(this.today).format('YYYY')
  uploads: any[];
  downloadURLs: any[];
  uploadPercent: any;

  constructor(
    private sasisopaService: SasisopaService,
    protected ref: NbDialogRef<FollowUpServiceComponent>,
    private firebaseStorageService: FirebaseStorageService,
  ) { }

  async ngOnInit() {
    await this.checkIfCreateOrEdit()
  }

  async store() {
    this.data.creation_date = moment(this.data.creation_date).format('YYYY-MM-DD')
    this.data.update_date = moment(this.data.creation_date).format('YYYY-MM-DD')
    this.data.station_id = this.stationId
    this.loading = true;


    if (!this.data.files.length) {
      this.loading = false;
      const [error, response] = await this.sasisopaService.createFollowService(this.data)
      if (error) {
        this.loading = false;
        return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
      }
      this.loading = false;
      await this.alert('Formato creado con éxito', 'success');
      this.ref.close(true);
    }
    await this.firebaseStorageService.setPath('images/procedure/8/format4');
    this.uploads = [];
    this.downloadURLs = [];

    for await (const [index, file] of this.data.files.entries()){
      const extension = file.name.split('.')[1];
      const filename = `${uuidv4()}.${extension}`;
      const fileRef = await this.firebaseStorageService.referenceCloudStorage(filename);
      const task = this.firebaseStorageService.taskCloudStorage(filename, file);

      // observe percentage changes
      this.uploadPercent = task.percentageChanges();

      // get notified when the download URL is available
      task.snapshotChanges().pipe(
        finalize(() => {
          fileRef.getDownloadURL().subscribe(async (url) => {
            this.downloadURLs.push(url);
            if (this.data.files.length === this.downloadURLs.length) {
              const [error] = await this.sasisopaService.createFollowService({ ...this.data, files: this.downloadURLs })
              if (error) return this.alert('Oops, ocurrio un error al cargar el archivo', 'error');
              this.loading = false;
            }
          });
        }),
      ).subscribe();
    }
  }

  async editFormat() {
    this.loading = true
    const [error, response] = await this.sasisopaService.editFollowService(this.infoEdit.id, this.data)
    if (error) {
      this.loading = false;
      return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    }
    this.loading = false
    await this.alert('Formato editado con éxito', 'success');
    this.ref.close(true);
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    return Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  async checkIfCreateOrEdit() {
    if (this.action === 'edit') {
      this.data = {
        station_id: this.infoEdit.station_id,
        document_name: this.infoEdit.document_name,
        entity: this.infoEdit.entity,
        creation_date: this.infoEdit.creation_date,
        update_date: this.infoEdit.update_date,
        backup_mode: this.infoEdit.backup_mode,
        final_disposition: this.infoEdit.final_disposition,
        files: this.infoEdit.files
      };
    }
  }

  async loadImage(event: any) {
    if (!event.target.files.length) return;
    this.loading = true;
    for await (const image of event.target.files) {
      const reader = new FileReader();
      await reader.readAsDataURL(image);
      this.data.files.push(image);
      this.loading = false;
    }
  }

  async delete(index: number) { this.data.files.splice(index, 1); }

}
